import axios from '@/libs/axios'

function dashboardParams({ from, to, supervisor_id: supervisorId }) {
  const params = { from, to }

  if (supervisorId !== undefined && supervisorId !== null && supervisorId !== '') {
    params.supervisor_id = supervisorId
  }

  return params
}

export default {
  namespaced: true,

  state: {
    salesOrdersByDay: null,
    orderTotalsVsRefundsByDay: null,
    ordersVsReturnsByDay: null,
    customersByDay: null,
    supervisorsOrdersByDay: null,
  },

  getters: {
    salesOrdersByDay(state) {
      return state.salesOrdersByDay
    },
    orderTotalsVsRefundsByDay(state) {
      return state.orderTotalsVsRefundsByDay
    },
    ordersVsReturnsByDay(state) {
      return state.ordersVsReturnsByDay
    },
    customersByDay(state) {
      return state.customersByDay
    },
    supervisorsOrdersByDay(state) {
      return state.supervisorsOrdersByDay
    },
  },

  mutations: {
    SET_SALES_ORDERS_BY_DAY(state, value) {
      state.salesOrdersByDay = value
    },
    SET_ORDER_TOTALS_VS_REFUNDS_BY_DAY(state, value) {
      state.orderTotalsVsRefundsByDay = value
    },
    SET_ORDERS_VS_RETURNS_BY_DAY(state, value) {
      state.ordersVsReturnsByDay = value
    },
    SET_CUSTOMERS_BY_DAY(state, value) {
      state.customersByDay = value
    },
    SET_SUPERVISORS_ORDERS_BY_DAY(state, value) {
      state.supervisorsOrdersByDay = value
    },
  },

  actions: {
    loadSalesOrdersByDay({ commit }, payload) {
      return axios.get('api/dashboard/sales/orders-by-day', {
        params: dashboardParams(payload),
      }).then((response) => {
        commit('SET_SALES_ORDERS_BY_DAY', response.data.data)
        return response.data.data
      })
    },
    loadOrderTotalsVsRefundsByDay({ commit }, payload) {
      return axios.get('api/dashboard/sales/order-totals-vs-refunds-by-day', {
        params: dashboardParams(payload),
      }).then((response) => {
        commit('SET_ORDER_TOTALS_VS_REFUNDS_BY_DAY', response.data.data)
        return response.data.data
      })
    },
    loadOrdersVsReturnsByDay({ commit }, payload) {
      return axios.get('api/dashboard/returns/orders-vs-returns-by-day', {
        params: dashboardParams(payload),
      }).then((response) => {
        commit('SET_ORDERS_VS_RETURNS_BY_DAY', response.data.data)
        return response.data.data
      })
    },
    loadCustomersByDay({ commit }, payload) {
      return axios.get('api/dashboard/customers/by-day', {
        params: dashboardParams(payload),
      }).then((response) => {
        commit('SET_CUSTOMERS_BY_DAY', response.data.data)
        return response.data.data
      })
    },
    loadSupervisorsOrdersByDay({ commit }, payload) {
      return axios.get('api/dashboard/staff/orders-by-day', {
        params: dashboardParams(payload),
      }).then((response) => {
        commit('SET_SUPERVISORS_ORDERS_BY_DAY', response.data.data)
        return response.data.data
      })
    },
  },
}
